import { Icon } from "components";
import { Table } from "components/atoms/BasicTable";
import { Footer } from "components/molecules/TableFooter";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { getLists, resetListSlice } from "store/slices/list.slice";
import { setCurrentPage } from "store/slices/ui.slice";
import { EnrichmentDTO } from "utils/dtos/enrichmentDTO";
import EntryFormatter from "utils/EntryFormatter";
import LeadHistoryBodyBulk from "./BodyBulk";
import InsightsModule from "./BodyVisitors/InsightsModule";
const LeadHistoryBulk: React.FC = () => {
  const pagesAvailable = 3,
    isMobile = window.innerWidth <= 810,
    dispatch = useAppDispatch(),
    [view] = useState("bulk"),
    [pageBulk, setPageBulk] = useState<number>(1),
    [pagination, setPagination] = useState(
      EntryFormatter.arrayCreateFromNumber(pagesAvailable)
    ),
    [paginationLast, setPaginationLast] = useState<number>(pagesAvailable),
    [BulkListData, setBulkListData] = useState<EnrichmentDTO[]>([]),
    [size, setSize] = useState<number>(20),
    { errorMessage: errorMessageBulk } = useAppSelector(
      (state) => state.lists.uploadData
    ),
    {
      isLoading: isLoadingBulkList,
      isSuccess: isSuccessBulkList,
      lists: bulkListDataEndpoint,
      isLastPage: isLastPageBulkList,
      numberOfLeads: numberOfLeadsBulkList,
    } = useAppSelector((state) => state.lists),
    handleSetSize = (sizeSelected: number) => {
      if (size === sizeSelected) return;
      setSize(sizeSelected);
      let searchParams: any = {
        size: sizeSelected,
      };
      setPageBulk(1);
      dispatch(resetListSlice());
      dispatch(getLists(searchParams));
    },
    loadPage = (pageSelected: number) => {
      if (view === "bulk") {
        if (pageBulk === pageSelected) return;
        setBulkListData([]);
        dispatch(resetListSlice());
        dispatch(getLists({ page: pageSelected, size }));
        setPageBulk(pageSelected);
      }
    },
    paginationRecalculate = () => {
      let nLeads = 0;
      if (view === "bulk") nLeads = numberOfLeadsBulkList;
      const pagesTotal = Math.ceil(nLeads / size);
      setPaginationLast(pagesTotal);
      if (size * pagesAvailable > nLeads) {
        const newPagesAvailable =
          EntryFormatter.arrayCreateFromNumber(pagesTotal);
        setPagination(newPagesAvailable);
      }
      let newPagination = EntryFormatter.arrayCreateStartingFromNumber(
        1,
        pagesAvailable
      );
      newPagination = newPagination.filter((number) => number <= pagesTotal);
      if (newPagination.length > 0 && newPagination.length < pagesAvailable)
        newPagination.unshift(newPagination[0] - 1);
      setPagination(newPagination);
    };
  useEffect(() => {
    if (!isSuccessBulkList) return;
    setBulkListData(bulkListDataEndpoint);
    paginationRecalculate();
  }, [isLoadingBulkList, isSuccessBulkList]);
  useEffect(() => {
    if (view === "bulk") {
      dispatch(resetListSlice());
      dispatch(getLists({ page: pageBulk, size }));
    }
  }, [dispatch, view]);
  useEffect(() => {
    dispatch(setCurrentPage("back"));
    window.analytics.page("Export Lists");
  }, []);

  let LeadHistoryBody = null;
  switch (view) {
    case "bulk": {
      LeadHistoryBody = (
        <LeadHistoryBodyBulk
          data={BulkListData}
          isLoading={isLoadingBulkList}
          isSuccess={isSuccessBulkList}
          errorMessage={String(errorMessageBulk) || ""}
          isMobile={isMobile}
          tableColumns={4}
        />
      );
      break;
    }
  }
  return (
    <div className="p-16 gap-4 overflow-y-auto">
      <div className="flex w-full items-center gap-5 border bg-gray-800 border-gray-700 p-6 text-white-500 rounded-2xl mb-4">
        <Icon name="download" />
        Export Lists
      </div>
      <div className=" border border-gray-700 rounded-2xl overflow-hidden">
        {["single", "bulk"].includes(view) ? (
          <>
            <Table className="mb-10">{LeadHistoryBody}</Table>
            <Footer totalItems={numberOfLeadsBulkList} pageSize={size} />
          </>
        ) : (
          <InsightsModule />
        )}
      </div>
    </div>
  );
};
export default LeadHistoryBulk;
